import { render, staticRenderFns } from "./ConfirmationDialogWrapper.vue?vue&type=template&id=32d817e2"
import script from "./ConfirmationDialogWrapper.vue?vue&type=script&lang=js"
export * from "./ConfirmationDialogWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports